/**
 * US states in the NKY Connect service area (postal abbreviations).
 * Sorted by full state name for display in dropdowns.
 */
export const SERVICE_AREA_STATES = [
  { name: 'Indiana', code: 'IN' },
  { name: 'Kentucky', code: 'KY' },
  { name: 'Ohio', code: 'OH' },
];

/** Postal codes only, A–Z by code. */
export const SERVICE_AREA_STATE_CODES = SERVICE_AREA_STATES.map((s) => s.code).sort();
